module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/PYq7lJ/images/cover.jpg?1685204505014",
      "alt": "This image is the cover for the book Silence Can Kill"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Silence Can Kill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Have faith. End hunger.")]), _c('p', [_vm._v("Ending hunger is a moral imperative that does not stand alone. Hunger thrives on the racial, social, and economic inequalities that are eating away at the soul of our nation and pulling us apart. But ending hunger could now become the cause that brings us together across partisan lines to make our economy include everyone and work for everybody.  ")]), _c('p', [_vm._v("The goal of ending hunger nationwide is not only noble but easily within reach. Taking up this goal could give us a corrective lens, a lens of hope for seeing ourselves and our country in a new way. It could also give us better vision for helping the world overcome extreme hunger and poverty.")]), _c('p', [_vm._v("Our failure to speak and write to members of Congress about hunger consigns millions of people here and abroad to diminished lives and premature death, so it is a silence that kills. We can break that silence by urging the nation’s leaders to help end hunger and humanize our economy. ")]), _c('p', [_vm._v("This book addresses all people of goodwill, including agnostics and atheists, but with a special word of concern for religious people—Christians in particular—who help through charity, but neglect to use the power of their citizenship against hunger.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Arthur Simon, Rick Steves\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    William B. Eerdmans Publishing Company\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0